import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ListItemIcon, MenuItem } from '@mui/material';

type HiddenSingleProps = {
    hidden?: boolean;
    disabled?: boolean;
    onClick?: () => void;
};

export const HiddenSingle = ({
    hidden,
    disabled,
    onClick,
}: HiddenSingleProps): JSX.Element => {
    return (
        <MenuItem onClick={onClick} disabled={disabled}>
            <ListItemIcon sx={{ mx: -1 }}>
                {hidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </ListItemIcon>
            {hidden ? 'Показать' : 'Скрыть'}
        </MenuItem>
    );
};
